import * as React from 'react';
import { PageWrapper } from '../../uiComponents/layout/PageWrapper';
import { ContentWrapper } from '../../uiComponents/layout/ContentWrapper';
import { SectionGroup } from '../../uiComponents/layout/SectionGroup';
import { Section } from '../../uiComponents/layout/Section';
import BrugerEdit from './BrugerEdit';
import { Bruger } from '../../models/Bruger';
import NotificationModule from '../../uiComponents/layout/Notification';
import { RouteComponentProps } from 'react-router';
import { Redirect } from 'react-router-dom';

export interface BrugerProfilProps extends RouteComponentProps<any> {
}

interface BrugerProfilState {
    brugerWasSaved: boolean;
}

class BrugerProfil extends React.Component<BrugerProfilProps, BrugerProfilState> {
    constructor(props: BrugerProfilProps) {
        super(props);      
        this.state = {
            brugerWasSaved: false
        };

        this.onBrugerSaved = this.onBrugerSaved.bind(this);
    }  

    onBrugerSaved(bruger: Bruger) {
        NotificationModule.showSuccess('', 'Dine oplysninger er gemt', false);       
        this.setState( {brugerWasSaved: true} );
    }

    render() {
        if (this.state.brugerWasSaved) {
            return <Redirect to={'/'} />;
        }

        return (
            <PageWrapper>
                <ContentWrapper>
                    <SectionGroup header='Brugerprofil'>
                        <Section>
                            <BrugerEdit onBrugerSaved={this.onBrugerSaved} isSubmitting={false} />                            
                        </Section>
                    </SectionGroup>
                </ContentWrapper>
            </PageWrapper>
        );
    }
}

export default BrugerProfil;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/pageComponents/bruger/BrugerProfil.tsx